/**
 * Politica de log, por corporacao.
 *
 * Log nao e uma decisao tecnica unica: um cliente com exigencia regulatoria
 * guarda um ano, outro descarta em trinta dias, um terceiro esta investigando
 * um problema e quer gravar tudo por uma semana. Esta tela e onde isso se
 * decide, por empresa.
 *
 * Consome a API do `liberty/core`, servida pelo mesmo host que o resto do
 * accounts ja usa.
 *
 * Mesmo desenho da tela de logs (ver modules/logs/routes.js): o codigo
 * `accounts.politica-de-log` mora na ferramenta `api/politica-de-log` do
 * servico `hliberty.politicadelog`, que e o que entrega os dados -- o nome
 * sai do `PoliticaDeLogRoutinesController` pelo `makePermissionStructure`.
 * Assim a tela so aparece onde `GET api/politica-de-log` e permitido.
 *
 * A API nao recorta por empresa: le e grava a politica de qualquer
 * corporacao e o padrao da plataforma. Por isso esta tela e de quem opera a
 * plataforma, e nao deve aparecer para empresa cliente so por ela ter o
 * accounts.
 */
const servico = 'hliberty.politicadelog';

export const nav = {
    section: 'Resources',
    title: 'LogPolicy',
    icon: 'database',
    route: '/politica-de-log',
    accordion: false,
    permissao: 'accounts.politica-de-log:ver',
    servico,
};

export default [
    {
        path: '/politica-de-log',
        name: '/politica-de-log',
        component: () => import('./pages/PoliticaDeLogPage.vue'),
        meta: { requiresAuth: true, permissao: 'accounts.politica-de-log:ver', servico },
    },
];
